<template>
  <app-warp title='门店后台' color='#efefef' padding='true'>
    <template #app-content>
      <div class="navListBox width100">
        <div class="height-177 headBgImg s_po_re" style='background:linear-gradient(90deg, #E2F4FF 0%, #DFE7FF 100%);'>
          <div class="s_flex_bian_c p-tb0-lr15 width100 p-t-15">
            <div class="s_flex_ali">
              <img class="width-60 height-60" src="@/assets/images/user.png" alt="">
              <div class="m-l-10">
                <p class="fz-16 s_font_b s_c333">经销商-张三</p>
                <p class="s_c9d m-t-5 fz-13 ">级别：省代</p>
              </div>
            </div>
            <div class="s_flex_center s_cfff width-100 height-35" style="background: linear-gradient(270deg, #5DB1FF 0%, #6A78FF 100%);border-radius: 20px;">
              <ScanOutlined />
              扫码核销
            </div>
          </div>
          <div class="s_flex_bian_c p-t-20">
            <div class="width33 text-ac">
              <p class="fz-18 s_font_b">12345</p>
              <p class="s_c666 fz-13">持有积分数</p>
            </div>
            <div class="width33 text-ac">
              <p class="fz-18 s_font_b">1234.00</p>
              <p class="s_c666 fz-13">本月收入</p>
            </div>
            <div class="width33 text-ac">
              <p class="fz-18 s_font_b">1234.00</p>
              <p class="s_c666 fz-13">可提现金额</p>
            </div>
          </div>
        </div>
        <div class="s_po_re p-t-10 s_bf p-l-10 p-r-10" style="top:-20px;left:50%;transform: translateX(-50%);border-top-left-radius: 10px;border-top-right-radius: 10px;">
          <div class="s_flex_wrap s_flex_bian_c p-b-10 p-t-10">
            <div class=" s_flex_center s_flex_fdc flex_1">
              <cIcon type="dfh" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">待发货</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="dhx" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">待核销</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="dtk" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">待退款</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="qbdd" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">全部订单</p>
            </div>
          </div>
          <div v-show="commonlyList.length">
            <div style="border-top:1px solid #EEEEEE;">
              <p class="m-b-15 fz-15 p-t-15 s_c333 s_font_b">常用应用</p>
              <div class="s_flex_wrap  s_flex_ali ">
                <div class="m-b-20 width25 s_flex_center s_flex_fdc" v-for='item in commonlyList' :key='item'>
                  <cIcon :type="item.icon" size="28" />
                  <p class="s_c333 text-ac fz-12 m-t-5">{{item.menu_name}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="height-50 s_bf width100 s_flex_bian_c s_bor_t_cd9 s_po_ab_bl">
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon type="sy_1" size="20" />首页
        </p>
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon type="sj" size="20" />数据
        </p>
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon type="wd" size="20" />我的
        </p>
      </div>
    </template>
    <template #app-sider>
      <div class="p-24">
        <SmallSquare content="设置经销商端常用功能，最多添加8个" />
        <a-button class="width-100 m-b-20 m-t-20" type="primary" @click="visible=true">添加</a-button>
        <a-table :pagination='false' bordered :columns='columns' :data-source='commonlyList'>
          <template v-slot:action="{ record,index }">
            <a-button type="link" @click='delModule(record,index)'>删除</a-button>
          </template>
        </a-table>
      </div>
      <a-button class="width-100 m-l-24 m-b-24" type="primary" v-has:setDealerUsedTemplate="setHomeData">保存</a-button>
    </template>
  </app-warp>
  <a-modal v-model:visible="visible" :width="1000" :footer="null" destroyOnClose>
    <moduleSelect :selectList="commonlyList" v-on:select="selectModule" />
  </a-modal>
</template>
<script>
  import { ScanOutlined } from "@ant-design/icons-vue";
  import { onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getDealerTemplateUsed, setDealerTemplateUsed } from '@/api/dealer'
  import moduleSelect from "./moduleSelect";
  import cIcon from "../components/c-icon";
  const columns = [
    {
      title: "应用名称",
      dataIndex: "menu_name",
      key: "menu_name",
    },
    {
      title: "所属模块",
      dataIndex: "module",
      key: "module",
    },
    {
      title: "操作",
      key: "action",
      width: 100,
      slots: { customRender: "action" },
    },
  ];
  export default {
    components: { ScanOutlined, cIcon, moduleSelect },
    setup(props) {
      const state = reactive({
        visible: false,
        commonlyList: []
      });
      const setHomeData = async () => {
        const hide = message.loading('正在加载中...', 0);
        var menu_ids = [];
        state.commonlyList.forEach(v=>{
          menu_ids.push(v.id)
        })
        let result = await setDealerTemplateUsed({menu_ids:menu_ids}).then((res) => res.data).catch(error=>error);
        setTimeout(hide);
        if (iscode(result)) {
          getHomeData();
          message.success(result.msg);
        } else {
          message.error(result.msg);
        }
      };
      const getHomeData = async () => {
        let result = await getDealerTemplateUsed().then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          state.commonlyList = result.data;
        } else {
          message.error(result.msg);
        }
      };
      onMounted(() => {
        getHomeData();
      });
      const selectModule = (data) => {
        state.visible = false;
        state.commonlyList = data;
      };
      const delModule = (data, index) => {
        state.commonlyList.splice(index, 1);
      };
      return {
        ...toRefs(state),
        columns,
        selectModule,
        delModule,
        setHomeData
      };
    },
  };
</script>
<style lang="less" scoped>
  .headBgImg {
    background-size: cover;
  }

  .navListBox {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 45px;
    overflow-y: scroll;
  }
</style>